import { Image } from "@chakra-ui/react";

import DmLogo from "images/logos/dm-logo.png";

// Partners that pick and pack an order themselves (picking-service's `partner`), not the
// marketplaces in DeliveryLogo / SupplierLogo. A Map, so a name like "constructor" can't match
// an inherited object key.
const PARTNER_LOGOS = new Map<string, string>([["dm", DmLogo]]);

// picking-service sends a partner it doesn't know yet as a number, so only these names are
// safe to show to the picker.
export function isKnownPartner(partner: string) {
  return PARTNER_LOGOS.has(partner.toLowerCase());
}

export function PartnerLogo({ partner }: { partner: string }) {
  const logo = PARTNER_LOGOS.get(partner.toLowerCase());
  if (!logo) return null;

  return (
    <Image
      src={logo}
      alt={partner}
      height="56px"
      width="auto"
      loading="lazy"
      data-testid="partner-logo"
    />
  );
}
